import { render } from "./EmergencyService.vue?vue&type=template&id=3a184ae5&scoped=true"
import script from "./EmergencyService.vue?vue&type=script&lang=js"
export * from "./EmergencyService.vue?vue&type=script&lang=js"

import "./EmergencyService.vue?vue&type=style&index=0&id=3a184ae5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a184ae5"]])

export default __exports__